import * as Sentry from '@sentry/react'
import { Fragment } from 'react'
import { useState } from 'react'
import { useHistory } from 'react-router'

import Button from 'src/components/common/button'
import Modal from 'src/components/common/modal'
import alerts from 'src/constants/alerts'
import routes from 'src/routes'
import { handlePromise } from 'src/utils/handlePromise'
import { ornaBackendClient } from 'src/utils/ornaBackendClient'

import openNotification from '../notification'

const SampleDataModal = ({ showModal, closeModal }) => {
    const history = useHistory()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const handleDeleteSampleData = async () => {
        setIsSubmitting(true)
        const [error] = await handlePromise(
            ornaBackendClient().post(`/api/removeSampleData`, {
                orgId: localStorage.getItem('userOrganizationId') || null,
            })
        )

        if (error) {
            Sentry.captureException(error, {
                extra: {
                    context: 'POST- removeSampleData',
                },
            })

            openNotification(
                alerts.ERROR,
                `Whoops, we didn't expect this. Please try again`,
                2
            )
            return
        }

        openNotification(alerts.SUCCESS, 'Sample Data Removed', 2)
        setIsSubmitting(false)
        closeModal()
        history.replace(routes.plan)
    }

    return (
        <Fragment>
            <Modal
                bodyStyle={{ background: '#2F3B52' }}
                visible={showModal}
                width={'600px'}
                closeModal={closeModal}
                closable={false}
                destroyOnClose={true}
            >
                <div className="mt-0">
                    <div className="text-base text-neutral-gray-75 2xl:text-lg">
                        Sample Data Found
                    </div>
                    <p className="mt-4 text-sm text-white 2xl:text-base">
                        Hurray! Looks like you're all set to experience ORNA on
                        your own. However, this would require us to delete the
                        sample data.
                    </p>
                    <div className="mt-8 mb-2 text-right">
                        <Button label="CANCEL" onClick={closeModal} />
                        <Button
                            intent={'primary'}
                            extendClass="ml-2"
                            label={isSubmitting ? 'DELETING..' : 'PROCEED'}
                            onClick={handleDeleteSampleData}
                        />
                    </div>
                </div>
            </Modal>
        </Fragment>
    )
}

export default SampleDataModal
